var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-card',[_c('v-card-title',{staticClass:"greyk lighten-4k"},[_c('h3',[_vm._v("Dashboard")]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-card-text',[_c('v-calendar')],1)],1)],1)],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6186a328","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/pages/accountant/dashboard.vue
// module id = FbUq
// module chunks = 0